document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    const swatches = card.querySelectorAll('.color-swatch');
    const images = card.querySelectorAll('.card__media img');

    const primaryImg = images[0];
    const secondaryImg = images.length > 1 ? images[1] : null;

    if (!primaryImg || swatches.length === 0) return;

    let originalPrimary = primaryImg.src;
    let originalSecondary = secondaryImg ? secondaryImg.src : null;

    // 🟢 Swatch click: update images and variant
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const newImg = swatch.dataset.variantImg;
        const newSecondary = swatch.dataset.variantSecondaryImg;
        const variantId = swatch.dataset.variantId;

        if (newImg) {
          primaryImg.src = newImg;
          primaryImg.srcset = `${newImg} 1x`;
          originalPrimary = newImg;
        }

        if (secondaryImg) {
          const validSecondary = newSecondary || newImg;
          secondaryImg.src = validSecondary;
          secondaryImg.srcset = `${validSecondary} 1x`;
          originalSecondary = validSecondary;
        }

        if (variantId) {
          card.setAttribute('data-variant-id', variantId);
        }

        swatches.forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');
      });
    });

    // 🟢 Hover effect for desktop only
    card.addEventListener('mouseenter', function () {
      if (window.innerWidth <= 768) return;
      const activeSwatch = card.querySelector('.color-swatch.active');
      if (!activeSwatch) return;

      const hoverImg = activeSwatch.dataset.variantImg;
      const hoverSecondary = activeSwatch.dataset.variantSecondaryImg || hoverImg;

      if (hoverImg) {
        primaryImg.src = hoverImg;
        primaryImg.srcset = `${hoverImg} 1x`;
      }

      if (secondaryImg && hoverSecondary) {
        secondaryImg.src = hoverSecondary;
        secondaryImg.srcset = `${hoverSecondary} 1x`;
      }
    });

    card.addEventListener('mouseleave', function () {
      if (window.innerWidth <= 768) return;
      if (originalPrimary) {
        primaryImg.src = originalPrimary;
        primaryImg.srcset = `${originalPrimary} 1x`;
      }

      if (secondaryImg && originalSecondary) {
        secondaryImg.src = originalSecondary;
        secondaryImg.srcset = `${originalSecondary} 1x`;
      }
    });

    // 🟢 Auto-select first swatch
    const firstSwatch = swatches[0];
    if (firstSwatch) {
      firstSwatch.classList.add('active');
      const firstImg = firstSwatch.dataset.variantImg;
      const firstSecondary = firstSwatch.dataset.variantSecondaryImg;
      const variantId = firstSwatch.dataset.variantId;

      if (firstImg) {
        primaryImg.src = firstImg;
        primaryImg.srcset = `${firstImg} 1x`;
        originalPrimary = firstImg;
      }

      if (secondaryImg) {
        const validSecondary = firstSecondary || firstImg;
        secondaryImg.src = validSecondary;
        secondaryImg.srcset = `${validSecondary} 1x`;
        originalSecondary = validSecondary;
      }

      if (variantId) {
        card.setAttribute('data-variant-id', variantId);
      }
    }

    // 🟢 Redirect to selected variant on card click (skip Add to Cart)
    const productLink = card.querySelector('a.full-unstyled-link');
    if (productLink) {
      card.addEventListener('click', function (e) {
        const clickedOnSwatch = e.target.closest('.color-swatch');
        const clickedOnAddToCart = e.target.closest('.quick-add__submit, .quick-add button');

        if (clickedOnSwatch || clickedOnAddToCart) return;

        const variantId = card.getAttribute('data-variant-id');
        const baseUrl = productLink.getAttribute('href');

        if (variantId && baseUrl) {
          e.preventDefault();
          window.location.href = `${baseUrl}?variant=${variantId}`;
        }
      });
    }
  });
});
